import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal, props } from 'cerebral/tags'

export default connect(
  {
    input: state`selectr.${props`namespace`}.input`,
    onChangeValue: signal`selectr.onChangeValue`,
    focusInput: state`selectr.${props`namespace`}.focusInput`,
    setFocusInput: signal`selectr.setFocusInput`
  },
  class Input extends Component {
    componentWillReceiveProps(nextProps) {
      if (nextProps.focusInput) {
        setTimeout(() => {
          this.input.focus()
        }, 0)
        const { setFocusInput, namespace } = this.props
        setFocusInput({ namespace, focus: false })
      }
    }

    render() {
      const {
        input = {},
        onChangeValue,
        namespace,
        overrideStyles = {}
      } = this.props

      const defaultStyle = {
        display: 'block',
        border: 0,
        outline: 0,
        flexGrow: 1
      }

      const externalStyle = overrideStyles.input || {}
      const style = { ...defaultStyle, ...externalStyle }

      return (
        <input
          ref={input => {
            this.input = input
          }}
          onChange={e => onChangeValue({ namespace, value: e.target.value })}
          value={input.value || ''}
          style={style}
          type={'text'}
        />
      )
    }
  }
)
